import { PackagesResponse } from "subModule/src/services/packages/interface";
import VerticalTabs from "common/ComponentSidebar/ComponentSideBar";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import { useNavigate } from "react-router-dom";

interface tabProps {
    params: any;
    selectedIndex: number;
    formData?: PackagesResponse | null;
}
export default function PackageTabs(props: tabProps) {
    const navigate = useNavigate();
    const handleChangeTabs = (tabId: number) => {
        if (tabId === 0) navigate(`/package/${props.params?.id}`);
        else if (tabId === 1) navigate(`/package/assign/service/${props.params?.id}`);
        else if (tabId === 2) navigate(`/package/assign/part/${props.params?.id}`);
        else if (tabId === 3) navigate(`/package/assign/station/${props.params?.id}`);
        else if (tabId === 4) navigate(`/package/assign/model/${props.params?.id}`);
        else if (tabId === 5) navigate(`/package/assign/price-list/${props.params?.id}`);
    }
    const tabs = [
        { id: 0, title: `edit`, child: <></> },
        { id: 1, title: `services`, child: <></> },
        { id: 2, title: `items`, child: <></> },
        { id: 3, title: `stations`, child: <></> },
        { id: 4, title: `models`, child: <></> },
        { id: 5, title: `priceList`, child: <></> },
    ];
    const disableTabs = tabs.map(tab => tab.id).filter(tabId => {
        switch (tabId) {
            case 0:
              return !checkPrivileges('ROLE_PACKAGE_UPDATE');
            case 1:
              return !checkPrivileges('ROLE_PACKAGE_SERVICE_ASSIGN') && !checkPrivileges('ROLE_PACKAGE_SERVICE_UNASSIGN');
            case 2:
              return !checkPrivileges('ROLE_PACKAGE_ITEM_ASSIGN') && !checkPrivileges('ROLE_PACKAGE_ITEM_UNASSIGN');
            case 3:
              return !checkPrivileges('ROLE_PACKAGE_STATION_ASSIGN') && !checkPrivileges('ROLE_PACKAGE_STATION_UNASSIGN');
            case 4:
              return !checkPrivileges('ROLE_PACKAGE_MODEL_ASSIGN') && !checkPrivileges('ROLE_PACKAGE_MODEL_UNASSIGN');
            case 5:
              return !checkPrivileges('ROLE_PACKAGE_PRICELIST_ASSIGN') && !checkPrivileges('ROLE_PACKAGE_PRICELIST_UNASSIGN');
            default:
              return false;
        }
    });
    const checkDisabledTabs = () => {
      const updatedDisableTabs = [...disableTabs];
      if (props?.formData?.applyToAllStations === true) {
        if (!updatedDisableTabs.includes(3)) {
          updatedDisableTabs.push(3);
        }
      }
      if (props?.formData?.itemGroup && ((props?.formData?.itemGroup as any)?.value === 1 || (props?.formData?.itemGroup as any)?.value === 2 || props?.formData?.itemGroup === 1 || props?.formData?.itemGroup === 2)) {
        if (!updatedDisableTabs.includes(2)) {
          updatedDisableTabs.push(2);
        }
      }
      return updatedDisableTabs;
    }
    return (<>
        <VerticalTabs tabs={tabs} selectedIndex={props.selectedIndex} handleChangeTabs={handleChangeTabs} disableTabNo={checkDisabledTabs()} />
    </>);
}